import Cart from "../partials/woocommerce-cart";

var woo = {
  init: function () {
    //woo.quick_cart.init();
    woo.events();
    woo.header.init();
    woo.update_cart();
  },

  events: function () {
    // Quantity event.
    $("body").on("click", ".number-input__btn", function () {
      let input = $(this).parent().find("input");
      const displayingQry = $(this).parent().find('.item-qty');

      if (!input.is(":disabled")) {
        let currentVal = parseInt(input.val());

        if ($(this).data("type") === "minus" && currentVal > 1) {
          input.val(currentVal - 1);
          input.change();
          displayingQry.html(currentVal - 1);
        } else if ($(this).data("type") === "plus") {
          input.val(currentVal + 1);
          displayingQry.html(currentVal + 1);
          input.change();
        }
      }
    });

    $("body").on("click", ".btn-filter", function( e ){
      e.preventDefault();
      $(".btn-filter").removeClass("active");
      $(this).addClass("active");
      const order = $(this).attr('data-sorting');
      const category = $(this).attr('data-category');
      const nonce = $(this).parent().find("#prod-nonce").val();
      $(this).addClass("btn-loading");
      woo.filter_products(order, category, nonce);
    });

    // Login form validation.
    $("form.login").on("submit", function (e) {
      const formEl = $(this);

      let errors = [];

      const usernameEl = formEl.find('input[name="username"]');
      if (!usernameEl.val()) {
        usernameEl.addClass("error");
        errors.push("username");
      } else {
        usernameEl.removeClass("error");
      }

      const passwordEl = formEl.find('input[name="password"]');
      if (!passwordEl.val()) {
        passwordEl.addClass("error");
        errors.push("password");
      } else {
        passwordEl.removeClass("error");
      }

      if (errors.length) {
        e.preventDefault();
      }
    });

    $('#showMore').on('click', function(e) {
      this.show_more();
    });
  },

  show_more: function() {

  },

  update_cart: function () {
    var timeout;

    $(".woocommerce").on("change", "input.qty", function () {
      if (timeout !== undefined) {
        clearTimeout(timeout);
      }

      timeout = setTimeout(function () {
        $("[name='update_cart']").trigger("click");
      }, 500);
    });
  },

  header: {
    init: function () {
      woo.header.get_cart_count();
      woo.header.events();
    },

    /**
     * Cart counts helper
     **/
    cart_count: function (count) {
      var btn = $(".cart-btn");

      switch (true) {
        case parseInt(count) > 0 && btn.find(".tooltip").length:
          btn.find(".tooltip").html(count);
          btn.find(".tooltip").addClass("visible");
          break;

        case parseInt(count) > 0:
          btn.find('.header__cart-amount').html( count )
          // btn.prepend('<span class="tooltip">' + count + "</span>");
          // btn.find(".tooltip").addClass("visible");
          break;

        case btn.find(".tooltip").length:
          btn.find(".tooltip").removeClass("visible");
          break;
      }
    },

    /**
     * Request cart count from server on pageload
     **/
    get_cart_count: function () {
      var btn = $(".cart-btn");
      $.ajax({
        url: ajaxurl,
        type: "POST",
        dataType: "JSON",
        data: {
          action: "get_cart_count",
        },
        success: function (response) {
          woo.header.cart_count(response);
        },
      });
    },

    events: function () {
      $("body").on("click", ".ajax_add_to_cart", function () {
        let button = $(this);
        var timer = setInterval(function () {
          if (button.hasClass("added")) {
            woo.header.get_cart_count();
            clearInterval(timer);
          }
        }, 200);
      });
    },
  },

  quick_cart: {
    element: $(".quick-cart"),

    init: function () {
      woo.quick_cart.toggle();
    },

    /**
     * Open QuickCart
     **/
    open: function () {
      woo.quick_cart.element.addClass("quick-cart--open");
      $("html").addClass("no-scroll");
    },

    /**
     * Close QuickCart
     **/
    close: function () {
      woo.quick_cart.element.removeClass("quick-cart--open");
      $("html").removeClass("no-scroll");
    },

    /**
     * Loaded QuickCart
     **/
    loaded: function () {
      woo.quick_cart.element.addClass("quick-cart--loaded");
    },

    /**
     * QuickCart functionality
     **/
    toggle: function () {
      $(".cart-btn").on("click", function (e) {
        e.preventDefault();

        switch (true) {
          case woo.quick_cart.element.hasClass("quick-cart--open"):
            woo.quick_cart.close();
            break;

          case woo.quick_cart.element.hasClass("quick-cart--loaded"):
            woo.quick_cart.open();
            break;

          default:
            woo.quick_cart.render();
            break;
        }
      });

      woo.quick_cart.element.on("click", ".quick-cart__close", function () {
        woo.quick_cart.close();
      });

      $(document).keyup(function (e) {
        if (woo.quick_cart.element.hasClass("quick-cart--loaded")) {
          if (e.keyCode === 27) {
            woo.quick_cart.close();
          }
        }
      });

      $(document).mouseup(function (e) {
        if (woo.quick_cart.element.hasClass("quick-cart--loaded")) {
          var container = woo.quick_cart.element.find(".quick-cart__inner");

          // if the target of the click isn't the container nor a descendant of the container
          if (!container.is(e.target) && container.has(e.target).length === 0) {
            woo.quick_cart.close();
          }
        }
      });
    },

    /**
     * Render quickcart
     **/
    render: function () {
      $.ajax({
        url: ajaxurl,
        type: "POST",
        dataType: "JSON",
        data: {
          action: "render_quick_cart",
        },
        beforeSend: function (xhr) {
          woo.quick_cart.open();
          woo.quick_cart.element.html(
            '<div class="quick-cart__loader"><i class="fa fa-cog fa-spin fa-2x fa-fw margin-bottom"></i></div>'
          );
        },
        success: function (response) {
          if (response) {
            woo.quick_cart.loaded();
            woo.quick_cart.element.html(response);
          } else {
            woo.quick_cart.close();
          }
        },
      });
    },

    /**
     * Update product cart product quantity
     */
    update_quantity: function ( product ) {

    }
  },

  filter_products( order, category, nonce ){
    $.ajax({
      url: ajaxurl,
      type: "POST",
      dataType: "JSON",
      data: {
        action: "filter_products",
        term_id: category,
        order_by: order,
        nonce
      },
    }).done((response) => {
      if (response) {
        $(".product-list__products").html(response.data.products);
        $(".btn-filter").removeClass("btn-loading");
      } else {

      }
    });
  },
};

export default woo;
